import script from "./ProfileAdditionalDataPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileAdditionalDataPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileAdditionalDataPage.vue?vue&type=style&index=0&id=24bb97ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24bb97ae"]])

export default __exports__